import { type ProjectCoverWrapper_portfolioProjectCover$key } from '#app/__generated__/relay/ProjectCoverWrapper_portfolioProjectCover.graphql.js';
import { ProjectCover } from './ProjectCover.js';
import { type ProjectCoverBaseProps, type ProjectCoverData } from './types.js';
import { graphql, useFragment } from '@contra/relay';

type CommonProps = ProjectCoverBaseProps & {
  readonly imageAlt?: string;
  readonly onLoad?: () => void;
};

type ProjectCoverDumbWrapperProps = CommonProps & {
  readonly data: ProjectCoverData;
};

type ProjectCoverWrapperProps = CommonProps & {
  readonly coverRef: ProjectCoverWrapper_portfolioProjectCover$key;
};

export const ProjectCoverDumbWrapper = ({
  data,
  imageAlt,
  onLoad,
  removeAnimation,
  width,
}: ProjectCoverDumbWrapperProps) => {
  if (data.__typename === 'PortfolioProjectImageCover') {
    return (
      <ProjectCover
        image={{
          animated: data.image.animated,
          uid: data.image.uid,
        }}
        imageAlt={imageAlt}
        onLoad={onLoad}
        removeAnimation={removeAnimation}
        width={width}
      />
    );
  } else if (data.__typename === 'PortfolioProjectTextCover') {
    return (
      <ProjectCover
        imageAlt={imageAlt}
        textCoverStyle={data.style}
        width={width}
      />
    );
  } else {
    throw new Error('Unhandled PortfolioProjectCover type');
  }
};

export const ProjectCoverWrapper = ({
  coverRef,
  imageAlt,
  onLoad,
  removeAnimation,
  width,
}: ProjectCoverWrapperProps) => {
  const data = useFragment<ProjectCoverWrapper_portfolioProjectCover$key>(
    graphql`
      fragment ProjectCoverWrapper_portfolioProjectCover on PortfolioProjectCover {
        ... on PortfolioProjectImageCover {
          __typename
          image {
            animated
            uid
          }
        }

        ... on PortfolioProjectTextCover {
          __typename
          style
        }
      }
    `,
    coverRef,
  );

  if (data.__typename === 'PortfolioProjectImageCover') {
    return (
      <ProjectCover
        image={{
          uid: data.image.uid,
        }}
        imageAlt={imageAlt}
        onLoad={onLoad}
        removeAnimation={removeAnimation}
        width={width}
      />
    );
  } else if (data.__typename === 'PortfolioProjectTextCover') {
    return (
      <ProjectCover
        imageAlt={imageAlt}
        textCoverStyle={data.style}
        width={width}
      />
    );
  } else {
    throw new Error('Unhandled PortfolioProjectCover type');
  }
};
